import { useEffect, useRef, useState } from 'react';
import { phoneLayoutQuery } from './device';

// The same illustrated preview follows a pointer on desktop and the reading position on a phone.
export function useCollectionFocus(key: string) {
  const register = useRef<HTMLDivElement>(null);
  const stage = useRef<HTMLElement>(null);
  const [focused, setFocused] = useState('');
  useEffect(() => {
    const media = matchMedia(phoneLayoutQuery);
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!media.matches || !register.current || !stage.current) return;
      const entries = Array.from(register.current.querySelectorAll<HTMLElement>('[data-practice]'));
      const stageBounds = stage.current.getBoundingClientRect();
      const bounds = register.current.getBoundingClientRect();
      if (bounds.bottom < 0 || stageBounds.top > window.innerHeight) return;
      const readingLine = stageBounds.bottom + Math.max(45, (window.innerHeight - stageBounds.bottom) * .3);
      let current = entries[0];
      for (const entry of entries) {
        if (entry.getBoundingClientRect().top <= readingLine) current = entry;
      }
      if (current) setFocused(current.dataset.practice || '');
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const resize = new ResizeObserver(schedule);
    if (register.current) resize.observe(register.current);
    if (stage.current) resize.observe(stage.current);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    media.addEventListener('change', schedule);
    setFocused('');
    schedule();
    return () => { cancelAnimationFrame(frame); resize.disconnect(); window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule); media.removeEventListener('change', schedule); };
  }, [key]);
  return { register, stage, focused, setFocused };
}
